import { render } from "./simcard-usage.vue?vue&type=template&id=0d6c605c"
import script from "./simcard-usage.vue?vue&type=script&lang=js"
export * from "./simcard-usage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__